/**
 * WOD3D AI hub (site-wide + product + cart)
 * 1) Floating Ayuda WOD3D
 * 2) Upload preflight
 * 3) Cart upsell pitches
 */
(function () {
  if (window.__wod3dAiHubBooted) return;
  window.__wod3dAiHubBooted = true;

  const SIMPLIFY_NOTE_FALLBACK =
    'Si es una foto o un diseño con mucho detalle, lo adaptamos a vector y colores planos, como en la galería.';
  const SIMPLIFY_NOTE = () => t('uploadSimplifyDefault', SIMPLIFY_NOTE_FALLBACK);
  const NOTE_CLASS = 'wod3d-upload-simplify-note';
  const AI_NOTE_FALLBACK =
    'Si está generada con IA, la adaptamos a vector y colores planos, como en la galería. Te enviaremos una propuesta antes de fabricar.';

  function i18n() {
    return window.wod3dI18n || {};
  }
  function t(key, fallback, vars) {
    let out = i18n()[key] || fallback || '';
    if (vars) {
      Object.keys(vars).forEach((k) => {
        out = String(out).split('{{ ' + k + ' }}').join(String(vars[k] ?? ''));
        out = String(out).split('{{' + k + '}}').join(String(vars[k] ?? ''));
      });
    }
    return out;
  }
  function currentLocale() {
    return (
      (window.wod3dAiAssist && window.wod3dAiAssist.locale) ||
      window.wod3dLocale ||
      'es'
    );
  }
  function simplifyNoteFromFlags({ complexity, aiGenerated, isPhoto, customerMessage } = {}) {
    if (complexity === 'simple') return '';
    // Theme locale strings always win — worker customerMessage is only a fallback
    // (and used to be Spanish-only, which broke EN/PT/DE/FR notices).
    if (aiGenerated) {
      return (
        t('uploadSimplifyAi', '') ||
        customerMessage ||
        AI_NOTE_FALLBACK
      );
    }
    if (isPhoto) {
      return (
        t('uploadSimplifyPhoto', '') ||
        customerMessage ||
        ''
      );
    }
    return (
      t('uploadSimplifyComplex', '') ||
      t('uploadSimplifyDefault', SIMPLIFY_NOTE_FALLBACK) ||
      customerMessage ||
      ''
    );
  }


  function addToCartLabel() {
    const btn = document.querySelector('product-form .product-form__submit, .product-form__submit');
    const label = (btn?.textContent || '').replace(/\s+/g, ' ').trim();
    if (label && !/agotado|sold out|nicht verfügbar/i.test(label)) return label;
    return t('uploadContinueButton', 'Crear mi parche');
  }

  function fileFieldWrap(fromEl) {
    return fromEl?.closest?.('.wcpa_type_file, .wcpa_field_wrap') || null;
  }

  function wrapHasUploadedFile(wrap) {
    if (!wrap) return false;
    if (wrap.querySelector('.wcpa_file_list li')) return true;
    if (wrap.querySelector('.wcpa_thumb img')) return true;
    const input = wrap.querySelector('input[type="file"]');
    return Boolean(input?.files?.length);
  }

  function noteForWrap(wrap) {
    const next = wrap.nextElementSibling;
    if (next?.classList?.contains(NOTE_CLASS)) return next;
    if (wrap.id) {
      return (
        document.getElementById(`wod3d-note-${wrap.id}`) ||
        wrap.parentElement?.querySelector(`.${NOTE_CLASS}[data-wod3d-for="${wrap.id}"]`)
      );
    }
    return null;
  }

  function uploadedFileName(wrap) {
    return (
      wrap?.querySelector('.wcpa_file_list .wcpa_file_details span')?.textContent ||
      wrap?.querySelector('.awpca_custom_file p')?.textContent ||
      ''
    ).trim();
  }

  function buildUploadHelpQuestion(wrap, message) {
    const fileName = uploadedFileName(wrap);
    const msg = String(message || wrap?.dataset.wod3dSimplifyMessage || SIMPLIFY_NOTE()).trim();
    const filePart = fileName
      ? t('uploadHelpFile', ' (archivo: {{ file }})', { file: fileName })
      : '';
    return (
      t('uploadHelpPrefix', 'He subido una imagen para personalizar el producto') +
      filePart +
      t('uploadHelpSuffix', '. Habéis mostrado este aviso: "{{ message }}". Explícame qué implica para mi pedido y resuelve mis dudas.', { message: msg })
    );
  }

  function setUploadSimplifyNote(wrap, show, message) {
    if (!wrap) return;
    let note = noteForWrap(wrap);
    if (!show) {
      note?.remove();
      return;
    }
    const text =
      String(message || wrap.dataset.wod3dSimplifyMessage || SIMPLIFY_NOTE()).trim() ||
      SIMPLIFY_NOTE();
    if (!note) {
      note = document.createElement('div');
      note.className = 'wod3d-cart-simplify-note ' + NOTE_CLASS;
      if (wrap.id) {
        note.id = `wod3d-note-${wrap.id}`;
        note.dataset.wod3dFor = wrap.id;
      }
      wrap.insertAdjacentElement('afterend', note);
    }

    let textEl = note.querySelector('.wod3d-upload-simplify-note__text');
    if (!textEl) {
      note.textContent = '';
      textEl = document.createElement('span');
      textEl.className = 'wod3d-upload-simplify-note__text';
      note.appendChild(textEl);
    }
    textEl.textContent = text;

    let labelEl = note.querySelector('.wod3d-upload-simplify-note__label');
    if (!labelEl) {
      labelEl = document.createElement('p');
      labelEl.className = 'wod3d-upload-simplify-note__label';
      note.insertBefore(labelEl, textEl);
    }
    labelEl.textContent = t('uploadNoticeLabel', 'Aviso');

    const ctaLabel = addToCartLabel();
    let continueEl = note.querySelector('.wod3d-upload-simplify-note__continue');
    if (!continueEl) {
      continueEl = document.createElement('p');
      continueEl.className = 'wod3d-upload-simplify-note__continue';
      textEl.insertAdjacentElement('afterend', continueEl);
    }
    continueEl.textContent = t(
      'uploadNoticeContinue',
      'No es un error. Puedes seguir y pulsar {{ button }}.',
      { button: ctaLabel }
    );

    let actions = note.querySelector('.wod3d-upload-simplify-note__actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.className = 'wod3d-upload-simplify-note__actions';
      note.appendChild(actions);
    }
    actions.querySelector('.wod3d-upload-simplify-note__go')?.remove();

    let aiBtn = actions.querySelector('.wod3d-upload-simplify-note__ai');
    if (!aiBtn) {
      aiBtn = note.querySelector('.wod3d-upload-simplify-note__ai');
      if (aiBtn) actions.appendChild(aiBtn);
    }
    if (!aiBtn) {
      aiBtn = document.createElement('button');
      aiBtn.type = 'button';
      aiBtn.className = 'wod3d-upload-simplify-note__ai';
      actions.appendChild(aiBtn);
    }
    aiBtn.setAttribute('aria-label', t('uploadMoreInfoAria', 'Más información sobre este aviso'));
    aiBtn.textContent = t('uploadMoreInfo', 'Más info');
  }

  function syncUploadSimplifyNotes(root = document) {
    root.querySelectorAll('.wcpa_type_file, .wcpa_field_wrap.wcpa_upload_custom_1').forEach((wrap) => {
      // Only show after preflight finished and classified as complex (never while pending).
      const show =
        wrapHasUploadedFile(wrap) && wrap.dataset.wod3dComplexity === 'complex';
      setUploadSimplifyNote(wrap, show);
    });
  }

  function mountUploadSimplifyNote() {
    const observer = new MutationObserver(() => {
      if (window.__wod3dResettingAddons) return;
      window.clearTimeout(mountUploadSimplifyNote._t);
      mountUploadSimplifyNote._t = window.setTimeout(() => syncUploadSimplifyNotes(), 60);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener(
      'change',
      (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'file') return;
        const wrap = fileFieldWrap(input);
        if (!wrap) return;
        // Wait for analysis — do not flash the simplify note on upload.
        wrap.dataset.wod3dComplexity = 'pending';
        delete wrap.dataset.wod3dSimplifyMessage;
        setUploadSimplifyNote(wrap, false);
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        if (!event.target.closest?.('.wcpa_remove_file')) return;
        window.setTimeout(() => {
          document
            .querySelectorAll('.wcpa_type_file, .wcpa_field_wrap.wcpa_upload_custom_1')
            .forEach((wrap) => {
              if (wrapHasUploadedFile(wrap)) return;
              delete wrap.dataset.wod3dComplexity;
              delete wrap.dataset.wod3dSimplifyMessage;
              setUploadSimplifyNote(wrap, false);
            });
          syncUploadSimplifyNotes();
        }, 80);
      },
      true
    );

    document.addEventListener(
      'wod3d:upload-cleared',
      (event) => {
        const wrap = event.detail?.wrap;
        if (!wrap) return;
        delete wrap.dataset.wod3dComplexity;
        delete wrap.dataset.wod3dSimplifyMessage;
        setUploadSimplifyNote(wrap, false);
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const btn = event.target.closest?.('.wod3d-upload-simplify-note__ai');
        if (!btn) return;
        event.preventDefault();
        event.stopPropagation();
        const note = btn.closest('.' + NOTE_CLASS);
        const wrap =
          (note?.dataset.wod3dFor && document.getElementById(note.dataset.wod3dFor)) ||
          note?.previousElementSibling;
        const question = buildUploadHelpQuestion(
          wrap,
          note?.querySelector('.wod3d-upload-simplify-note__text')?.textContent
        );
        if (typeof window.wod3dOpenHelpChat === 'function') {
          window.wod3dOpenHelpChat(question);
        }
      },
      true
    );

    document.addEventListener('wod3d:addons-reset', () => {
      document.querySelectorAll('.' + NOTE_CLASS).forEach((el) => el.remove());
      document
        .querySelectorAll('[data-wod3d-complexity], [data-wod3d-simplify-message]')
        .forEach((el) => {
          delete el.dataset.wod3dComplexity;
          delete el.dataset.wod3dSimplifyMessage;
        });
    });

    syncUploadSimplifyNotes();
  }

  // Product/upload observers mount only from boot() when product assist is needed.

  const cfg = window.wod3dAiAssist || {};
  if (!cfg.enabled || !cfg.endpoint) return;

  // Always read latest config (product page may enrich it after this file loads).
  function liveCfg() {
    return Object.assign({}, cfg, window.wod3dAiAssist || {});
  }

  const baseEndpoint = String(cfg.endpoint || '').replace(/\/suggest\/?$/i, '');

  function apiUrl(path) {
    return `${baseEndpoint}${path}`;
  }

  async function postAi(path, body) {
    const c = liveCfg();
    const headers = { 'Content-Type': 'application/json' };
    if (c.token) headers['X-WOD3D-Token'] = c.token;
    const res = await fetch(apiUrl(path), {
      method: 'POST',
      headers,
      body: JSON.stringify({ ...body, locale: currentLocale() }),
    });
    return res.json().catch(() => ({}));
  }

  function isPersonalizableProduct() {
    const c = liveCfg();
    return Boolean(
      c.personalizable ||
        (c.productTags || []).some((t) => /personaliz/i.test(String(t)))
    );
  }

  /* ---------------- 1) Floating Ayuda WOD3D ---------------- */
  function detectProductContext() {
    const c = liveCfg();
    const personalizable = isPersonalizableProduct();
    const titleFromDom = (
      document.querySelector('.product__title h1')?.textContent ||
      document.querySelector('.product__title')?.textContent ||
      ''
    ).trim();

    return {
      productTitle: c.productTitle || titleFromDom,
      productType: c.productType || '',
      productTags: c.productTags || [],
      productDescription: c.productDescription || '',
      personalizable,
    };
  }

  function mountDesignAssist() {
    if (document.querySelector('.wod3d-help-fab')) return;

    const ctx = detectProductContext();
    const onProduct = Boolean(ctx.productTitle);
    const quick = onProduct
      ? ctx.personalizable
        ? [
            [t('helpQProductUse', '¿Para qué sirve este producto?'), t('helpLabelProduct', 'Producto')],
            [t('helpQShippingProduct', '¿Cómo funciona el envío y dónde veo el plazo?'), t('helpLabelShipping', 'Envíos')],
            [t('helpQMaterial', '¿De qué material está hecho?'), t('helpLabelMaterial', 'Material')],
            [t('helpQPersonalize', '¿Se puede personalizar?'), t('helpLabelPersonalize', 'Personalizar')],
          ]
        : [
            [t('helpQProductUse', '¿Para qué sirve este producto?'), t('helpLabelProduct', 'Producto')],
            [t('helpQShippingProduct', '¿Cómo funciona el envío y dónde veo el plazo?'), t('helpLabelShipping', 'Envíos')],
            [t('helpQMaterial', '¿De qué material está hecho?'), t('helpLabelMaterial', 'Material')],
            [t('helpQCustom', '¿Hacéis diseños o proyectos a medida?'), t('helpLabelCustom', 'A medida')],
          ]
      : [
          [t('helpQShippingGlobal', '¿Cómo funcionan los envíos?'), t('helpLabelShipping', 'Envíos')],
          [t('helpQMaterialsGlobal', '¿Qué materiales usáis?'), t('helpLabelMaterial', 'Material')],
          [t('helpQPersonalizeGlobal', '¿Se pueden personalizar los productos?'), t('helpLabelPersonalize', 'Personalizar')],
          [t('helpQCustomGlobal', '¿Hacéis diseños a medida?'), t('helpLabelCustom', 'A medida')],
        ];

    const waIcon =
      `<svg class="wod3d-help-fab__wa-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">` +
      `<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>` +
      `</svg>`;

    const root = document.createElement('div');
    root.className = 'wod3d-help-fab';
    root.innerHTML =
      `<button type="button" class="wod3d-help-fab__tab" aria-label="${t('helpOpenAria', 'Abrir ayuda WOD3D')}">` +
      waIcon +
      `</button>` +
      `<div class="wod3d-help-fab__launcher-wrap">` +
      `<button type="button" class="wod3d-help-fab__launcher" aria-expanded="false" aria-controls="wod3d-help-panel" aria-label="${t('helpLauncherAria', 'Ayuda WOD3D')}">` +
      `<span class="wod3d-help-fab__launcher-icon" aria-hidden="true">${waIcon}</span>` +
      `<span class="wod3d-help-fab__launcher-label">${t('helpLauncherLabel', 'Ayuda')}</span>` +
      `</button>` +
      `<button type="button" class="wod3d-help-fab__minimize" aria-label="${t('helpHideAria', 'Ocultar ayuda')}">×</button>` +
      `</div>` +
      `<div class="wod3d-help-fab__panel" id="wod3d-help-panel" hidden>` +
      `<div class="wod3d-help-fab__header">` +
      `<div class="wod3d-help-fab__brand">` +
      `<span class="wod3d-help-fab__badge" aria-hidden="true">WOD3D</span>` +
      `<div class="wod3d-help-fab__title">${t('helpTitle', '¿En qué te ayudamos?')}</div>` +
      `<p class="wod3d-help-fab__intro">${t('helpIntro', 'Producto, envíos, materiales o personalización.')}</p>` +
      `</div>` +
      `<button type="button" class="wod3d-help-fab__close" aria-label="${t('helpCloseAria', 'Cerrar')}">×</button>` +
      `</div>` +
      `<div class="wod3d-help-fab__thread" aria-live="polite"></div>` +
      `<div class="wod3d-help-fab__section wod3d-help-fab__section--quick">` +
      `<div class="wod3d-help-fab__label">${t('helpQuickLabel', 'Sugerencias rápidas')}</div>` +
      `<div class="wod3d-help-fab__quick">` +
      quick.map(([q, label]) => `<button type="button" data-q="${q}">${label}</button>`).join('') +
      `</div>` +
      `</div>` +
      `<form class="wod3d-help-fab__form">` +
      `<div class="wod3d-help-fab__composer">` +
      `<textarea class="wod3d-help-fab__input" placeholder="${t('helpPlaceholder', 'Escribe tu duda…')}" maxlength="220" rows="3" autocomplete="off"></textarea>` +
      `<button type="submit" class="wod3d-help-fab__send">${t('helpSend', 'Preguntar')}</button>` +
      `</div>` +
      `</form>` +
      `<div class="wod3d-help-fab__footer">` +
      `<a class="wod3d-help-fab__wa" href="${liveCfg().whatsappUrl || 'https://wa.me/34603024030'}" target="_blank" rel="noopener">${t('helpWhatsapp', 'Hablar por WhatsApp')}</a>` +
      `</div>` +
      `</div>`;

    document.body.appendChild(root);

    const STORAGE_KEY = 'wod3d-help-minimized';
    const backdrop = document.createElement('div');
    backdrop.className = 'wod3d-help-fab__backdrop';
    backdrop.hidden = true;
    document.body.appendChild(backdrop);

    const launcher = root.querySelector('.wod3d-help-fab__launcher');
    const tab = root.querySelector('.wod3d-help-fab__tab');
    const minimizeBtn = root.querySelector('.wod3d-help-fab__minimize');
    const panel = root.querySelector('.wod3d-help-fab__panel');
    const closeBtn = root.querySelector('.wod3d-help-fab__close');
    const thread = root.querySelector('.wod3d-help-fab__thread');
    const quickSection = root.querySelector('.wod3d-help-fab__section--quick');
    const form = root.querySelector('.wod3d-help-fab__form');
    const input = root.querySelector('.wod3d-help-fab__input');
    let backdropTimer = null;

    function fadeBackdrop(show) {
      window.clearTimeout(backdropTimer);
      if (show) {
        backdrop.hidden = false;
        backdrop.setAttribute('aria-hidden', 'false');
        // Double rAF so opacity transition runs after display is restored.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            backdrop.classList.add('is-visible');
            document.body.classList.add('wod3d-help-open');
          });
        });
        return;
      }
      backdrop.classList.remove('is-visible');
      document.body.classList.remove('wod3d-help-open');
      backdrop.setAttribute('aria-hidden', 'true');
      backdropTimer = window.setTimeout(() => {
        backdrop.hidden = true;
      }, 320);
    }

    function setMinimized(minimized) {
      root.classList.toggle('is-minimized', minimized);
      if (minimized) {
        root.classList.remove('is-open');
        panel.hidden = true;
        launcher.setAttribute('aria-expanded', 'false');
      }
      try {
        sessionStorage.setItem(STORAGE_KEY, minimized ? '1' : '0');
      } catch (_) {}
    }

    function setOpen(open) {
      if (open) {
        setMinimized(false);
        root.classList.add('is-open');
        panel.hidden = false;
        launcher.setAttribute('aria-expanded', 'true');
        fadeBackdrop(true);
        window.setTimeout(() => input.focus(), 80);
        return;
      }

      root.classList.remove('is-open');
      panel.hidden = true;
      launcher.setAttribute('aria-expanded', 'false');
      fadeBackdrop(false);
      setMinimized(true);
    }

    // Start tucked away so it never blocks the UI by default.
    setMinimized(true);

    function isCartDrawerOpen() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return false;
      if (drawer.classList.contains('active')) return true;
      return Boolean(drawer.querySelector('wod-sidebar-drawer.is-open, .wod-sidebar.is-open'));
    }

    function syncCartHidden() {
      const hide = isCartDrawerOpen();
      root.classList.toggle('is-cart-hidden', hide);
      if (hide && root.classList.contains('is-open')) setOpen(false);
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      new MutationObserver(syncCartHidden).observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
      });
    }
    syncCartHidden();

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function scrollThread() {
      thread.scrollTop = thread.scrollHeight;
    }

    function appendMessage(role, text, { thinking = false } = {}) {
      const row = document.createElement('div');
      row.className = `wod3d-help-fab__msg wod3d-help-fab__msg--${role}`;
      if (thinking) row.classList.add('is-thinking');
      row.innerHTML =
        `<div class="wod3d-help-fab__bubble">${
          thinking
            ? '<span class="wod3d-help-fab__typing" aria-label="' + t('helpTypingAria', 'Escribiendo') + '"><i></i><i></i><i></i></span>'
            : escapeHtml(text)
        }</div>`;
      thread.appendChild(row);
      root.classList.add('has-chat');
      scrollThread();
      return row;
    }

    backdrop.addEventListener('click', (event) => {
      event.stopPropagation();
      setOpen(false);
    });
    tab.addEventListener('click', (event) => {
      event.stopPropagation();
      setMinimized(false);
      setOpen(true);
    });
    launcher.addEventListener('click', (event) => {
      event.stopPropagation();
      setOpen(!root.classList.contains('is-open'));
    });
    minimizeBtn.addEventListener('click', (event) => {
      event.stopPropagation();
      setMinimized(true);
    });
    closeBtn.addEventListener('click', (event) => {
      event.stopPropagation();
      setOpen(false);
    });
    root.addEventListener('click', (event) => event.stopPropagation());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
    document.addEventListener('click', () => {
      if (!root.classList.contains('is-open')) return;
      setOpen(false);
    });

    async function ask(question) {
      const text = String(question || '').trim();
      if (!text || root.classList.contains('is-loading')) return;

      const liveCtx = detectProductContext();
      appendMessage('user', text);
      input.value = '';
      if (quickSection) quickSection.hidden = true;

      const thinkingRow = appendMessage('assistant', '', { thinking: true });
      root.classList.add('is-loading');

      try {
        const data = await postAi('/design-assist', {
          question: text,
          productTitle: liveCtx.productTitle,
          productType: liveCtx.productType,
          productTags: liveCtx.productTags,
          productDescription: liveCtx.productDescription,
          personalizable: liveCtx.personalizable,
        });
        const answer =
          data.answer || t('helpFallbackAnswer', 'No dispongo de esa información. Te recomiendo contactar con nosotros.');
        thinkingRow.classList.remove('is-thinking');
        thinkingRow.querySelector('.wod3d-help-fab__bubble').textContent = answer;
      } catch (_) {
        thinkingRow.classList.remove('is-thinking');
        thinkingRow.querySelector('.wod3d-help-fab__bubble').textContent =
          t('helpErrorAnswer', 'Ahora mismo no puedo responder. Mejor escríbenos por WhatsApp.');
      } finally {
        root.classList.remove('is-loading');
        scrollThread();
        input.focus();
      }
    }

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      ask(input.value);
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        ask(input.value);
      }
    });
    root.querySelectorAll('[data-q]').forEach((btn) => {
      btn.addEventListener('click', () => ask(btn.getAttribute('data-q')));
    });

    window.wod3dOpenHelpChat = function (question) {
      setOpen(true);
      const q = String(question || '').trim();
      if (q) window.setTimeout(() => ask(q), 160);
    };
  }

  /* ---------------- 2) Upload preflight ---------------- */
  const VOLUME_PRODUCT_HANDLES = new Set(['creamos-tu-parche-personalizado']);

  function isVolumeClassifyProduct() {
    const handle = String(liveCfg().productHandle || '');
    return VOLUME_PRODUCT_HANDLES.has(handle);
  }

  function isPetKeychainProduct() {
    const c = liveCfg();
    if (c.petKeychain) return true;
    const tags = Array.isArray(c.productTags) ? c.productTags : [];
    if (tags.some((tag) => /mascota|^pet$|meshy|pet.?keychain/i.test(String(tag)))) return true;
    return /mascota|pet-keychain|llavero-mascota/i.test(String(c.productHandle || ''));
  }

  function findProductForm(fromEl) {
    return (
      fromEl.closest('form[action*="/cart/add"]') ||
      fromEl.closest('product-form form') ||
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function setLineProperty(form, key, value) {
    if (!form) return;
    const name = `properties[${key}]`;
    let input = form.querySelector(`input[type="hidden"][name="${CSS.escape(name)}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function applyComplexityProps(form, complexity, aiGenerated) {
    const safeComplexity = complexity === 'simple' ? 'simple' : 'complex';
    setLineProperty(form, '_wod3d_complexity', safeComplexity);
    setLineProperty(form, '_wod3d_ai', aiGenerated ? 'yes' : 'no');
  }

  function isSvgFile(file) {
    if (!file) return false;
    return file.type === 'image/svg+xml' || /\.svg$/i.test(String(file.name || ''));
  }

  function readFileAsDataUrl(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => reject(reader.error || new Error('read failed'));
      reader.readAsDataURL(file);
    });
  }

  function loadImageFromUrl(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('image load failed'));
      img.src = url;
    });
  }

  /**
   * Vision APIs need a raster image. SVG is drawn to canvas → PNG data URL
   * so preflight can classify simple vs complex (and AI) like any other upload.
   */
  async function fileToPreflightDataUrl(file) {
    if (!isSvgFile(file)) {
      return readFileAsDataUrl(file);
    }

    let svgText = await file.text();
    // Ensure drawable size when the SVG has no explicit dimensions.
    if (!/\b(width|height|viewBox)\s*=/i.test(svgText)) {
      svgText = svgText.replace(
        /<svg\b/i,
        '<svg width="1024" height="1024" viewBox="0 0 1024 1024"'
      );
    } else if (!/\bwidth\s*=/i.test(svgText) || !/\bheight\s*=/i.test(svgText)) {
      svgText = svgText.replace(/<svg\b([^>]*)>/i, (full, attrs) => {
        let next = attrs || '';
        if (!/\bwidth\s*=/i.test(next)) next += ' width="1024"';
        if (!/\bheight\s*=/i.test(next)) next += ' height="1024"';
        return `<svg${next}>`;
      });
    }

    const blob = new Blob([svgText], { type: 'image/svg+xml;charset=utf-8' });
    const objectUrl = URL.createObjectURL(blob);
    try {
      const img = await loadImageFromUrl(objectUrl);
      const maxSide = 1024;
      const srcW = Math.max(1, img.naturalWidth || img.width || maxSide);
      const srcH = Math.max(1, img.naturalHeight || img.height || maxSide);
      const scale = Math.min(1, maxSide / Math.max(srcW, srcH));
      const w = Math.max(1, Math.round(srcW * scale));
      const h = Math.max(1, Math.round(srcH * scale));
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('canvas unavailable');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      return canvas.toDataURL('image/png');
    } finally {
      URL.revokeObjectURL(objectUrl);
    }
  }

  function mountPreflight() {
    const onFile = async (input) => {
      if (isPetKeychainProduct()) return;
      const file = input.files && input.files[0];
      const form = findProductForm(input);
      const wrap = fileFieldWrap(input);
      // Safer default for cart props until classified as simple.
      if (isVolumeClassifyProduct()) applyComplexityProps(form, 'complex', false);
      if (wrap) {
        wrap.dataset.wod3dComplexity = 'pending';
        delete wrap.dataset.wod3dSimplifyMessage;
        setUploadSimplifyNote(wrap, false);
      }

      if (!file) return;
      if (!file.type.startsWith('image/') && !isSvgFile(file)) return;

      try {
        const imageDataUrl = await fileToPreflightDataUrl(file);
        const data = await postAi('/preflight', {
          imageDataUrl,
          fileName: file.name,
          productTitle: liveCfg().productTitle || '',
        });
        if (isVolumeClassifyProduct()) {
          applyComplexityProps(form, data.complexity, data.aiGenerated);
        }
        if (wrap) {
          const isSimple = data.complexity === 'simple';
          wrap.dataset.wod3dComplexity = isSimple ? 'simple' : 'complex';
          if (isSimple) {
            delete wrap.dataset.wod3dSimplifyMessage;
            setUploadSimplifyNote(wrap, false);
          } else {
            const msg =
              simplifyNoteFromFlags({
                complexity: data.complexity,
                aiGenerated: data.aiGenerated,
                isPhoto: data.isPhoto,
                customerMessage: data.customerMessage,
              }) || SIMPLIFY_NOTE();
            wrap.dataset.wod3dSimplifyMessage = msg;
            setUploadSimplifyNote(wrap, wrapHasUploadedFile(wrap), msg);
          }
        }
      } catch (_) {
        if (isVolumeClassifyProduct()) applyComplexityProps(form, 'complex', false);
        // Analysis failed: keep note hidden (no false flash).
        if (wrap) {
          wrap.dataset.wod3dComplexity = 'pending';
          setUploadSimplifyNote(wrap, false);
        }
      }
    };

    document.addEventListener(
      'change',
      (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'file') return;
        if (!input.closest('.wcpa_wrap')) return;
        onFile(input);
      },
      true
    );

    // Ensure default complex props exist before first add-to-cart on this product.
    if (isVolumeClassifyProduct()) {
      const form = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
      applyComplexityProps(form, 'complex', false);
    }

    document.addEventListener('wod3d:addons-reset', () => {
      if (!isVolumeClassifyProduct()) return;
      const form = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
      applyComplexityProps(form, 'complex', false);
    });
  }

  /* ---------------- 3) Cart upsell ---------------- */
  async function renderUpsell(cartProduct) {
    const host = document.querySelector('#CartDrawer-UpsellAI, .wod3d-cart-upsell');
    if (!host || !cartProduct?.id) return;

    host.hidden = false;
    host.innerHTML = '<div class="wod3d-cart-upsell__loading">Buscando complementos…</div>';

    try {
      const recUrl = `${window.Shopify?.routes?.root || '/'}recommendations/products.json?product_id=${cartProduct.id}&limit=6&intent=related`;
      const recRes = await fetch(recUrl);
      const recData = await recRes.json();
      const products = Array.isArray(recData.products) ? recData.products : [];
      const candidates = products.slice(0, 6).map((p) => ({
        id: String(p.id),
        title: p.title,
        url: p.url,
        image: p.featured_image || (p.images && p.images[0]) || '',
        price: p.price ? (Number(p.price) / 100).toFixed(2) + ' €' : '',
      }));

      const ranked = await postAi('/upsell', {
        cartProductTitle: cartProduct.title || '',
        candidates,
      });

      const items = Array.isArray(ranked.items) ? ranked.items : candidates.slice(0, 2);
      if (!items.length) {
        host.hidden = true;
        return;
      }

      host.innerHTML =
        `<div class="wod3d-cart-upsell__title">Completa tu setup</div>` +
        `<div class="wod3d-cart-upsell__list">` +
        items
          .map(
            (item) =>
              `<a class="wod3d-cart-upsell__item" href="${item.url}">` +
              (item.image ? `<img src="${item.image}" alt="" width="64" height="64" loading="lazy">` : '') +
              `<span><strong>${item.title}</strong><em>${item.pitch || ''}</em>${item.price ? `<small>${item.price}</small>` : ''}</span>` +
              `</a>`
          )
          .join('') +
        `</div>`;
    } catch (_) {
      host.hidden = true;
    }
  }

  function bindUpsellEvents() {
    document.addEventListener('cart:update', (event) => {
      const detail = event.detail || {};
      const item = detail.product || detail.cartData?.product || null;
      if (item) renderUpsell(item);
    });

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (payload) => {
          const cartData = payload?.cartData || {};
          const productId = cartData.product_id || cartData.items?.[0]?.product_id;
          const title = cartData.product_title || cartData.title || cartData.items?.[0]?.product_title;
          if (productId) renderUpsell({ id: productId, title: title || '' });
        });
      } catch (_) {}
    }
  }

  function needsProductAssist() {
    try {
      var flag = window.wod3dAiAssist && window.wod3dAiAssist.productAssist;
      // Accept only explicit booleans / 'true' / page type 'product'.
      // Guard against Liquid precedence bugs that leaked request.page_type (e.g. "index").
      if (flag === true || flag === 'true' || flag === 'product') return true;
    } catch (e) {}
    try {
      return Boolean(
        document.querySelector('.wcpa_wrap, .wcpa_type_file, .wcpa_field_wrap.wcpa_upload_custom_1')
      );
    } catch (e2) {
      return false;
    }
  }

  function boot() {
    // A) Global floating help — always
    mountDesignAssist();
    // C) Cart upsell listeners — drawer can open on any page
    bindUpsellEvents();
    // B) Upload preflight + simplify notes — product / WCPA only
    if (needsProductAssist()) {
      mountUploadSimplifyNote();
      mountPreflight();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
